import React, { useEffect, useRef } from "react";

// reactstrap components
import { Card, CardBody, Row, Col } from "reactstrap";

import { withGoogleMap, GoogleMap, withScriptjs, InfoWindow, Marker } from "react-google-maps";
import Geocode from "react-geocode";
import Autocomplete from 'react-google-autocomplete';

let GoogleMapsAPI = 'AIzaSyBs18XKLLip0CBo__x3a33ADc5N1VA1mfE'
Geocode.setApiKey(GoogleMapsAPI);
Geocode.setLanguage("en");
// Geocode.enableDebug();

const Map = React.forwardRef((props, ref) => {
    const { state, setState, setLandmark, style, fillUpData, setNumber, setName } = props;
    const [locationState, setLocationState] = React.useState({
        meetingPoint: "",
        address: '',
        city: '',
        area: '',
        state: '',
        country: '',
        mapPosition: {
            lat: 0,
            lng: 0
        },
        markerPosition: {
            lat: 0,
            lng: 0
        },
    });


    React.useEffect(() => {
        setState({ ...state, ...locationState })
        // eslint-disable-next-line
    }, [locationState]);

    React.useEffect(() => {
        if (fillUpData?.address?.coordinates?.lat) {
            initializeMap(fillUpData?.address?.coordinates?.lat, fillUpData?.address?.coordinates?.long, true)
        }
        if (navigator.geolocation && !fillUpData?.address?.coordinates?.lat) {
            navigator.geolocation.getCurrentPosition(position => {

                initializeMap(position.coords.latitude, position.coords.longitude)
            })
        }

        // eslint-disable-next-line
    }, []);


    /**
     * Component should only update ( meaning re-render ), when the user selects the address, or drags the pin
     *
     * @param nextProps
     * @param nextState
     * @return {boolean}
     */
    /**
     * Get the city and set the city input value to the one selected
     *
     * @param addressArray
     * @return {string}
     */

    const initializeMap = (lat, lng, isFillData) => {
        Geocode.fromLatLng(lat, lng).then(
            response => {
                const address = response.results[0].formatted_address,
                    addressArray = response.results[0].address_components,
                    city = getCity(addressArray),
                    area = getArea(addressArray),
                    state = getState(addressArray),
                    country = getCountry(addressArray);
                if (!isFillData) {
                    setLandmark(area)
                }
                else {
                    setLandmark(fillUpData?.Landmark)
                    setName(fillUpData?.userName)
                    setNumber(fillUpData?.number)
                }
                setLocationState({
                    ...locationState,
                    mapPosition: {
                        lat: lat,
                        lng: lng
                    },
                    markerPosition: {
                        lat: lat,
                        lng: lng
                    },
                    address: (address) ? address : '',
                    area: (area) ? area : '',
                    city: (city) ? city : '',
                    state: (state) ? state : '',
                    country: (country) ? country : ''

                })
            },
            error => {
                console.log(error, ">>>")
            }
        );
    }

    const getCity = (addressArray) => {
        let city = '';
        for (let i = 0; i < addressArray.length; i++) {
            for (let j = 0; j < addressArray[i].types.length; j++) {
                if ('locality' === addressArray[i].types[j]) {
                    city = addressArray[i].long_name;
                    return city;
                }
            }
        }
    };
    /**
     * Get the area and set the area input value to the one selected
     *
     * @param addressArray
     * @return {string}
     */
    const getArea = (addressArray) => {
        let area = '';
        for (let i = 0; i < addressArray.length; i++) {
            if (addressArray[i].types[0]) {
                for (let j = 0; j < addressArray[i].types.length; j++) {
                    if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
                        area = addressArray[i].long_name;
                        return area;
                    }
                }
            }
        }
    };

    const getState = (addressArray) => {
        let state = '';
        for (let i = 0; i < addressArray.length; i++) {
            for (let i = 0; i < addressArray.length; i++) {
                if (addressArray[i].types[0] && 'administrative_area_level_1' === addressArray[i].types[0]) {
                    state = addressArray[i].long_name;
                    return state;
                }
            }
        }
    };

    const getCountry = (addressArray) => {
        let country = '';
        for (let i = 0; i < addressArray.length; i++) {
            if (addressArray[i].types[0]) {
                for (let j = 0; j < addressArray[i].types.length; j++) {
                    if ('country' === addressArray[i].types[j]) {
                        country = addressArray[i].long_name;
                        return country;
                    }
                }
            }
        }
    };
    /**
     * Get the address and set the address input value to the one selected
     *
     * @param addressArray
     * @return {string}
     */
    /**
     * And function for city,state and address input
     * @param event
     */
    /**
     * This Event triggers when the marker window is closed
     *
     * @param event
     */
    const onInfoWindowClose = (event) => {

    };

    /**
     * When the marker is dragged you get the lat and long using the functions available from event object.
     * Use geocode to get the address, city, area and state from the lat and lng positions.
     * And then set those values in the state.
     *
     * @param event
     */
    const onMarkerDragEnd = (event) => {
        let newLat = event.latLng.lat(),
            newLng = event.latLng.lng();

        Geocode.fromLatLng(newLat, newLng).then(
            response => {
                const address = response.results[0].formatted_address,
                    addressArray = response.results[0].address_components,
                    city = getCity(addressArray),
                    area = getArea(addressArray),
                    state = getState(addressArray),
                    country = getCountry(addressArray);
                setLandmark(area)
                setLocationState({
                    address: (address) ? address : '',
                    area: (area) ? area : '',
                    city: (city) ? city : '',
                    state: (state) ? state : '',
                    country: (country) ? country : '',
                    markerPosition: {
                        lat: newLat,
                        lng: newLng
                    },
                    mapPosition: {
                        lat: newLat,
                        lng: newLng
                    },
                    ...{ name: area, coordinates: [newLat, newLng], lat: newLat, lng: newLng }
                })
            },
            error => {
            }
        );
    };

    /**
     * When the user types an address in the search box
     * @param place
     * 
     */

    const onPlaceSelected = (place) => {
        if (place.geometry) {
            const addressArray = place.address_components,
                address = place.formatted_address,
                city = getCity(addressArray),
                area = getArea(addressArray),
                state = getState(addressArray),
                country = getCountry(addressArray),
                latValue = place.geometry.location.lat(),
                lngValue = place.geometry.location.lng();
            setLandmark(area)
            setLocationState({
                ...locationState,
                autocompleteValue: (city) ? city : '',
                address: (address) ? address : '',
                area: (area) ? area : '',
                city: (city) ? city : '',
                state: (state) ? state : '',
                country: (country) ? country : '',
                markerPosition: {
                    lat: latValue,
                    lng: lngValue
                },
                mapPosition: {
                    lat: latValue,
                    lng: lngValue
                },
                ...{ name: area, coordinates: [place.geometry.location.lat(), place.geometry.location.lng()], lat: place.geometry.location.lat(), lng: place.geometry.location.lng(), meetingPoint: place.address_components[0].long_name }
            })
        }
    };

    const exampleMapStyles = [
        {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {
                    color: "#eeeeee",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9e9e9e",
                },
            ],
        },
    ];

    const AsyncMap = React.useMemo(
        () => withScriptjs(
            withGoogleMap(
                props => (
                    <div>
                        <GoogleMap
                            options={{
                                styles: exampleMapStyles,
                            }}
                            google={props.google}
                            defaultZoom={15}
                            defaultCenter={{ lat: locationState.mapPosition.lat, lng: locationState.mapPosition.lng }}
                        >

                            {/* InfoWindow on top of marker */}
                            <InfoWindow
                                onClose={onInfoWindowClose}
                                position={{ lat: (locationState.markerPosition.lat + 0.0018), lng: locationState.markerPosition.lng }}
                            >
                                <div>
                                    <span style={{ padding: 0, margin: 0, color: "black" }}>
                                        {locationState.address}
                                    </span>
                                </div>
                            </InfoWindow>
                            {/*Marker*/}
                            <Marker google={props.google}
                                name={'Dolores park'}
                                draggable={true}
                                onDragEnd={onMarkerDragEnd}
                                position={{ lat: locationState.markerPosition.lat, lng: locationState.markerPosition.lng }}
                            />
                            <Marker />
                            {/* For Auto complete Search Box */}
                            <Autocomplete
                                style={style ?
                                    style
                                    : {
                                        boxSizing: 'border-box',
                                        border: '2px solid #ccc',
                                        borderRadius: '4px',
                                        fontSize: '16px',
                                        backgroundColor: 'white',
                                        backgroundImage: `url('search.svg')`,
                                        backgroundPosition: '6px 8px',
                                        backgroundSize: '24px',
                                        backgroundRepeat: 'no-repeat',
                                        padding: '12px 20px 12px 40px',
                                        width: '50%',
                                        height: '42px',
                                        position: 'absolute',
                                        top: '25px',
                                        left: '60px'
                                    }}
                                placeholder="search"
                                onPlaceSelected={onPlaceSelected}
                                types={['(regions)']}
                                componentRestrictions={{ country: 'pk' }}
                            />
                        </GoogleMap>
                    </div>
                )
            )
        ), [locationState]
    )

    return (
        <>
            <div className="content map">
                <Row>
                    <Col md="12">
                        <Card className="card-plain">
                            <CardBody >
                                {locationState.mapPosition.lat || locationState.mapPosition.lng ?
                                    <AsyncMap
                                        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GoogleMapsAPI}&libraries=places`}
                                        loadingElement={
                                            <div style={{ height: `100%` }} />
                                        }
                                        containerElement={
                                            <div style={{ height: "500px", marginTop: '0px' }} />
                                        }
                                        mapElement={
                                            <div style={{ height: `100%` }} />
                                        }
                                    /> : ""}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
})

export default Map
